const apiurl=()=>{
    // var url="http://192.168.1.35:4000";
    // var url="http://13.200.47.127:5000";
    var url="https://api.kavinsacademy.com";
    return url;
}
export default apiurl;